enum EnumShirtSize {
    XS = "XS",
    S = "S",
    M = "M",
    L = "L",
    XL = "XL",
    "2XL" = "2XL",
    "3XL" = "3XL",
    "4XL" = "4XL",
    "5XL" = "5XL"
}

export default EnumShirtSize
